export default class AddClassRoomController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    classRooms,
    ClassRoomService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.classRooms = classRooms;
    this.ClassRoomService = ClassRoomService;
  }

  cancel() {
    this.$mdDialog.cancel();
  }

  save(form) {
    if (form.$invalid) {
      return false;
    }

    this.ClassRoomService.assignClassRoom(this.selectedClassRoom)
      .then(() => {
        this.$mdDialog.hide();
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Dodano salę do świetlicy')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }
}
